import React from "react";
import { Helmet } from "react-helmet-async";

const SEO = ({ title, meta, activeLanguage, defaultLanguage, translate }) => {
  return (
    <Helmet defaultTitle="Crane" titleTemplate="%s | Crane">
      <html lang={activeLanguage?.code || defaultLanguage} />
      <title>{translate(`page_titles.${title}`)}</title>
      {meta || ``}
    </Helmet>
  );
};

export default SEO;
